// extracted by mini-css-extract-plugin
module.exports =  {"root":"_0d624b9a27--root--xP_76"};